import * as React from "react";
import { PropertiesDBLight } from "./PropertiesDBLight"

export function changeState(name, value) {
	var state = {};
	state[name] = value;
	this.setState(state);
}

var propertiesDB = new PropertiesDBLight();

export class SelectValue extends React.Component<{ options: any; value: any; label?: string; onChange: any; }, object> {
	onChange(event) {
		if (this.props.onChange)
			this.props.onChange(event.target.value);
	}
	render() {
		return (
			<div className="settings-row">
				{this.props.label ? (
					<div className="settings-caption">
						<label>{this.props.label}:</label>
					</div>
				) : ""}
				<div className="settings-value">
					<select value={this.props.value} onChange={this.onChange.bind(this)}>
						{this.props.options.map(option => <option key={option.value} value={option.value}>{option.text}</option>)}
					</select>
				</div>
			</div>
		);
	}
}

// export class InputValue extends React.Component<{ type: string; value: number; label?: string; onChange: any; }, any> {
// 	private property: any;
// 	private SIUnits: any;

// 	constructor(props) {
// 		super(props);
// 		this.state = { value: this.props.value };
// 	}
// 	onChangeValue(event) {
// 		if (this.props.onChange) {
// 			this.props.onChange(event.target.value);
// 		}
// 	}
// 	render() {
// 		return (
// 			<div className="settings-row">
// 				{this.props.label ? (
// 					<div className="settings-caption">
// 						<label>{this.props.label}:</label>
// 					</div>
// 				) : ""}
// 				<div className="settings-value">
// 					<input type={this.props.type || "text"} value={this.state.value} onChange={this.onChangeValue.bind(this)} />
// 				</div>
// 			</div>
// 		);
// 	}
// }

export interface InputNumberProps {
	value: number;
	label?: string;
	onChange: any;
	property?: string;
	units?: string;
	min?: number;
	max?: number;
}

/////// 26/08/2018 note: forms for full properties are using improved algorithm which separates dependencies - will change this version in due course

// value is always in SI units, even if initial units are non-SI
export class InputNumber extends React.Component<InputNumberProps, any> {
	private property: any;
	private SIUnits: any;

	constructor(props) {
		super(props);
		if (this.props.property) {
			this.property = propertiesDB.FindProperty(this.props.property);
			this.SIUnits = propertiesDB.GetPropertySIUnit(this.property);
			var value = this.props.value;
			var units = this.SIUnits;
			if (this.props.units) {
				units = propertiesDB.FindPropertyUnit(this.property, this.props.units);
				if (units !== this.SIUnits) {
					value = propertiesDB.ConvertUnits(value, this.SIUnits, units);
				}
			}
			this.state = { value: value, units: units };
		} else {
			this.state = { value: this.props.value };
		}
	}
	getSIValue(value: number, units: any): number {
		if (units === this.SIUnits) return value;
		return propertiesDB.ConvertUnits(value, units, this.SIUnits);
	}
	onChangeValue(event) {
		if (this.props.onChange) {
			var val: number = parseFloat(event.target.value);
			if (!isNaN(val)) {
				this.setState({ value: val });
				this.props.onChange(this.getSIValue(val, this.state.units));
			}
			else {
				this.setState({ value: "" });
				this.props.onChange(this.getSIValue(0, this.state.units));
			}
		}
	}
	onChangeUnits(sUnits: string) {
		var units = propertiesDB.FindPropertyUnit(this.property, sUnits);
		this.setState({ units: units });
		this.props.onChange(this.getSIValue(this.state.value, units));
	}
	render() {
		return (
			<div className="settings-row">
				{this.props.label ? (
					<div className="settings-caption">
						<label>{this.props.label}:</label>
					</div>
				) : ""}
				<div className="settings-value">
					<input type="number" value={this.state.value} onChange={this.onChangeValue.bind(this)} min={this.props.min} max={this.props.max} />
					{this.props.property ? (
						<UnitPicker property={this.props.property} units={this.state.units.name[0]} onChange={this.onChangeUnits.bind(this)} />
					) : ""}
				</div>
			</div>
		);
	}
}

// value is always in SI units, even if initial units are non-SI
export class OutputNumber extends React.Component<{ value: number; label?: string; property?: string; units?: string; digits?: number }, any> {
	private property: any;
	private SIUnits: any;

	constructor(props) {
		super(props);
		if (this.props.property) {
			this.property = propertiesDB.FindProperty(this.props.property);
			this.SIUnits = propertiesDB.GetPropertySIUnit(this.property);
			var units = this.SIUnits;
			if (this.props.units) units = propertiesDB.FindPropertyUnit(this.property, this.props.units);
			this.state = { units: units };
		}
	}
	getValueAsString() {
		if(isNaN(this.props.value)) {
			return "Arithmetic Error";
		}
		else if (this.props.digits) {
			return propertiesDB.ConvertUnits(this.props.value, this.SIUnits, this.state.units).toFixed(this.props.digits || 2);
		}
		else {
			return propertiesDB.ConvertUnits(this.props.value, this.SIUnits, this.state.units);
		}
	}
	onChangeUnits(sUnits: string) {
		var units = propertiesDB.FindPropertyUnit(this.property, sUnits);
		this.setState({ units: units });
	}
	render() {
		return (
			<span>
				{this.props.label ? this.props.label + ": " : ""}
				{this.getValueAsString()}
				<span>&nbsp;</span>
				{this.props.property ? (
					<UnitPicker property={this.props.property} units={this.state.units.name[0]} onChange={this.onChangeUnits.bind(this)} />
				) : ""}
			</span>
		);
	}
}

export class UnitPicker extends React.Component<{ property: string; units?: string; onChange: any; }, any> {
	private property: any;

	constructor(props) {
		super(props);
		this.property = propertiesDB.FindProperty(this.props.property);
		if (!this.property) this.property = propertiesDB.FindProperty("dimensionless");
		var units = this.property.units[0];
		if (this.props.units) units = this.props.units;
		this.state = { units: units };
	}
	onChange(event) {
		var sUnits = event.target.value;
		if (!sUnits) return;
		this.setState({ units: sUnits });
		if (this.props.onChange) this.props.onChange(sUnits);
	}
	render() {
		return (
			<select value={this.state.units} onChange={this.onChange.bind(this)}>
				{this.property.units.map(unit => <option key={unit.name[0]} value={unit.name[0]} >{unit.name[0]}</option>)}
			</select>
		);
	}
}

// image that will not leave a missing image on the page if it fails
export class IMG extends React.Component<{ src: any; value: any; onChange: any; }, any> {
	constructor(props) {
		super(props);
		this.state = { src: this.props.src };
		this.state = { errored: false };
	}
	handleError(event) {
		this.setState({ errored: true });
		this.setState({ src: this.props.src });
	}
	render() {
		if (this.state.errored && this.state.src === this.props.src) {
			return null;
		} else {
			var attributes = { onError: this.handleError };
			for (var prop in this.props) { // pass attributes through
				if (prop == "data-bind" || prop == "updateFunction") continue;
				if (attributes[prop] === undefined) attributes[prop] = this.props[prop];
			}
			return React.createElement("img", attributes);
		}
	}
}
